export type ReactiveFormSubmitStatus = 'idle' | 'submitting' | 'completed' | 'failed';

export interface ReactiveFormSubmitStateSnapshot {
    readonly status: ReactiveFormSubmitStatus;
    readonly hasSubmittedRequest: boolean;
    readonly hasCompletedRequest: boolean;
}

/** Tracks generic submit lifecycle flags without owning concrete request execution. */
export class ReactiveFormSubmitState {
    private statusValue: ReactiveFormSubmitStatus = 'idle';

    public get status(): ReactiveFormSubmitStatus {
        return this.statusValue;
    }

    public get hasSubmittedRequest(): boolean {
        return this.statusValue === 'submitting' || this.statusValue === 'completed';
    }

    public get hasCompletedRequest(): boolean {
        return this.statusValue === 'completed';
    }

    public reset(): ReactiveFormSubmitStateSnapshot {
        this.statusValue = 'idle';
        return this.snapshot();
    }

    public markSubmitting(): ReactiveFormSubmitStateSnapshot {
        this.statusValue = 'submitting';
        return this.snapshot();
    }

    public markCompleted(): ReactiveFormSubmitStateSnapshot {
        this.statusValue = 'completed';
        return this.snapshot();
    }

    public markFailed(): ReactiveFormSubmitStateSnapshot {
        this.statusValue = 'failed';
        return this.snapshot();
    }

    public snapshot(): ReactiveFormSubmitStateSnapshot {
        return {
            status: this.statusValue,
            hasSubmittedRequest: this.hasSubmittedRequest,
            hasCompletedRequest: this.hasCompletedRequest,
        };
    }
}
